export default {
  signUpSuccess: 'Successfully registered! You\'ve been signed in as well.',
  signUpFailure: 'Registration failed. Email may be taken, or passwords don\'t match.',
  signInSuccess: 'Welcome!',
  signInFailure: 'Failed to sign in. Check your email and password and try again.',
  signOutSuccess: 'Come back soon!',
  changePasswordSuccess: 'Password changed successfully!',
  changePasswordFailure: 'Failed to change passwords. Check your old password and try again.',
  createBrewSuccess: 'Successfully saved your recipe!',
  retrieveNoBrews: 'You have no brews saved!',
  successfulDeletion: 'Recipe successfully removed!',
  submitSuccess: 'Successfully updated recipe!'
}



// WEBPACK FOOTER //
// ./src/components/AutoDismissAlert/messages.js